import { render } from "./RepresentativeData.vue?vue&type=template&id=441f23d9"
import script from "./RepresentativeData.vue?vue&type=script&lang=js"
export * from "./RepresentativeData.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__